import * as React from "react";
import { Switch, Route, Router, RouteComponentProps } from "react-router-dom";
import {Landing} from "./pages/landing";
import {Dash} from "./pages/dash";
import {PaymentPage} from "./pages/payment";
import DocumentSightingPage from "./pages/documentSighting/documentSighting";
import RegisterPage from "./pages/register";
import RegisterVerifyPage from "./pages/registerVerify";
import {hashHistory, route, navigateTo} from "./links";
import {ErrorPage} from "./pages/error";
import {OutagePage} from "./pages/outage";
import {appState} from "./state/state";
import {config} from './config/config';
import AuthenticationProvider from "./webServices/AuthenticationProvider";
import {authenticationService} from "./webServices/authenticationService";

const {voi} = appState;

export function renderRoutes() {
  /**
   * Verify
   * - that the token is still valid and if not take them to `login`
   * - that the tnc accepted is valid
   */
  const goNext = async (nextState: any, replace: (location: any) => void, next: () => any) => {
    let userDetails = {
      name: sessionStorage.getItem('displayName')
    };

    // for testing purpose only
    if (!userDetails.name && window.location.hostname === 'localhost') {
      userDetails.name = 'Test User';
    }

    if (userDetails.name) {
      authenticationService.storeUserDetails(userDetails);
    } else {
      window.location.replace(config.portalConfig.portalLoginUrl);
    }

    next();
    return;
  }


  const verifyUserCameFromRegisterNew = (nextState: any, replace: (location: any) => void, next: () => any) => {
    /**
     * If no phone number jump them back to step 1
     * This is to prevent the case where UI crashes in later steps, user refreshes the browser thinking it will just work.
     */
    if (!voi.phoneNumber.value) {
      replace({
        pathname: route.registerNew()
      });
      next();
      return;
    }

    /** Also check auth */
    goNext(nextState, replace, next);
  }

  const newVoiEnter = (nextState: any, replace: (location: any) => void, next: () => any) => {
    if (voi.transactionStatus.value !== '') {
      sessionStorage.setItem('status', voi.transactionStatus.value);
    }
    voi.reset();
    goNext(nextState, replace, next);
  }

  const entryFromPortal = (nextState: any, replace: (location: any) => void, next: () => any) => {
    newVoiEnter(nextState, replace, next);
  }

  const cancelOrder = (nextState: any, replace: (location: any) => void, next: () => any) => {
    voi.reset();
    goNext(nextState, replace, next);
    navigateTo(route.dash(), true)
  }

  type ReplaceFn = (location: { pathname: string } | string | any) => void;
  type NextFn = () => any;
  type OnEnter = (nextState: RouteComponentProps, replace: ReplaceFn, next: NextFn) => void;

  const GuardedRoute = ({
    component: Component,
    onEnter,
    ...rest
  }: {
  component: React.ComponentType<any>;
    onEnter?: OnEnter;
    path: string;
    exact?: boolean;
  }) => {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (onEnter) {
            // If a guard performs a redirect, we must NOT render the protected component in this render pass.
            // This mirrors react-router's old onEnter behavior and avoids flicker + side-effects/crashes.
            let didRedirect = false;
            const replace: ReplaceFn = (location) => {
              didRedirect = true;
              props.history.replace(location);
            };
            onEnter(props, replace, () => undefined);
            if (didRedirect) {
              return null;
            }
          }

          return <Component {...props} />;
        }}
      />
    );
  };
  const routes = (
    <AuthenticationProvider content={
      <Router history={hashHistory}>
        <Switch>
          <Route path={'/' + route.welcome()} component={Landing} />
          <GuardedRoute path={'/' + route.registerNew()} component={RegisterPage} onEnter={newVoiEnter} />
          <GuardedRoute path={'/' + route.registerFromPortal()} component={RegisterPage} onEnter={entryFromPortal} />
          <GuardedRoute path={'/' + route.registerEdit()} component={RegisterPage} onEnter={goNext} />
          <GuardedRoute path={'/' + route.registerVerify()} component={RegisterVerifyPage} onEnter={verifyUserCameFromRegisterNew} />
          <GuardedRoute path={'/' + route.payment()} component={PaymentPage} onEnter={goNext} />
          <GuardedRoute path={'/' + route.documentSighting()} component={DocumentSightingPage} onEnter={verifyUserCameFromRegisterNew} />
          <GuardedRoute path={'/' + route.dash()} component={Dash} onEnter={goNext} />
          <GuardedRoute path={'/' + route.cancel()} component={Landing} onEnter={cancelOrder} />
          <Route path={'/' + route.error()} component={ErrorPage} />
          <Route path={'/' + route.outage()} component={OutagePage} />
          <Route component={Landing} /> {/* fallback for unmatched paths */}
        </Switch>

      </Router>
    }/>
  );

  return routes;
}
